module.exports = __webpack_public_path__ + "static/img/result_desk_lx_angle.d4b4095.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desk_lx_angle.jpg
// module id = LIl5
// module chunks = 3